import React from 'react';
import styles from './textBodies.module.css';

/**
 * Miolo do PDF de anamnese: uma linha "pergunta / resposta" por item do
 * modelo, com a observação quando houver (mesmo conteúdo do AnamneseInfo).
 *
 * `items`: [{ label, answer, observation }] já normalizados (parseAnamnesisAnswers).
 */
export const AnamnesisReportBody = ({ items }) => {
  const list = Array.isArray(items) ? items : [];

  return (
    <div>
      {list.map((item, index) => (
        <div key={index} className={styles.qa}>
          <span className={styles.question}>{item.label}</span>
          <span className={item.answer ? styles.answer : styles.answerEmpty}>{item.answer || 'Não informado'}</span>
          {item.observation && <span className={styles.observation}>Observação: {item.observation}</span>}
        </div>
      ))}
    </div>
  );
};

export default AnamnesisReportBody;
